import { AxiosInstanceProvider } from '../../../../core/hooks';
import { Timespan } from '../../../chart-settings/model';
import { SlaMonitoredServicesHttpQuery } from '../../config';
import { SlaMonitoredServiceApiModel } from '../../model';

export interface SlaMonitoredServicesHttpGetPayloadModel {
  customerId: number;
  timespan: Timespan;
}

export type SlaMonitoredServicesHttpGetResponseModel = SlaMonitoredServiceApiModel[];

export const getSlaMonitoredServices = async (
  axios: AxiosInstanceProvider, {
    customerId,
    timespan,
  }: SlaMonitoredServicesHttpGetPayloadModel,
): Promise<SlaMonitoredServicesHttpGetResponseModel> => {
  const response = await axios().get<SlaMonitoredServicesHttpGetResponseModel>(
    SlaMonitoredServicesHttpQuery['GetSlaMonitoredServices'].url.replace('{customerId}', customerId.toString(10)), {
      params: {
        timespan,
      },
    },
  );

  return response.data;
};
